module.exports = __webpack_public_path__ + "static/media/sdmt1.88cd2ef9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt1.svg
// module id = 341
// module chunks = 0